//Mixin for date-fns
import {
    format as fnsFormat,
    parseISO as fnsParseISO,
    isValid as fnsIsValid,
    parse as fnsParse,
    formatRelative,
    subDays,
    getHours,
    getTime,
    getMinutes
  } from 'date-fns'
  import { fr, enGB, es, de, nl, it } from 'date-fns/locale'

export const ednDate = {
    data() {
      return {
        fr,
        enGB,
        es,
        de,
        nl,
        it
      }
    },
    props: {
        // date format
        format: {
            type: String,
            default: 'dd/MM/yyyy',
        },
        // locale of the user
        locale: {
            type: String,
            default: 'fr',
        },
    },
    methods: {
        fnsFormat,
        fnsParseISO,
        fnsIsValid,
        fnsParse,
        formatRelative,
        subDays,
        getHours,
        getTime,
        getMinutes,
        /***
         * Returns the language to use in date-fns
         */
        getDateFnsLocale() {
            switch (this.locale) {
            case 'en':
            case 'enGB':
                return this.enGB;
                break;
            case 'fr':
            case '':
            default:
                return this.fr;
                break;
            }
        },
    }
}